import React, { useState } from 'react'
import { 
  Col, 
  Row, 
  Image, 
  Input, 
  Space, 
  Button, 
  // Layout 
} from 'antd';
import { login } from '../../Utils/api/Auth';
import { 
  UserOutlined, 
  LockOutlined, 
  EyeInvisibleOutlined, 
  EyeTwoTone 
} from '@ant-design/icons';
// import { useNavigate } from "react-router-dom"
import HeaderLogo from "../../Assets/alta_logo.png"
// import HeaderImage from "../../Assets/golf-img.jpg"
import toast from 'react-hot-toast';
import { 
  // getToken, 
  refreshPage,
} from '../../Utils/Common';
import { HashLoader } from 'react-spinners';
const Login = () => {
  // const navigate = useNavigate()
  const [loginCredential, setLoginCredential] = useState({
    email: '',
    password: '',
  })
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (e) => {
    const {name, value} = e.target
    setLoginCredential({
      ...loginCredential,
      [name]: value
    })
  }
  
  const onSubmit = async () => {
    setIsLoading(true);
    const response = await login(loginCredential);
    if (response && response.data){
      localStorage.setItem('token', JSON.stringify(response.data.token));
      localStorage.setItem('user_id', JSON.stringify(response.data.id));
      localStorage.setItem('name', JSON.stringify(response.data.name));
      localStorage.setItem('role_id', JSON.stringify(response.data.role_id));
      localStorage.setItem('role_name', JSON.stringify(response.data.role));
      localStorage.setItem('token_expiry', JSON.stringify(response.data.token_expiry));
      toast.success(response.data.message)
      setTimeout(()=>{
        refreshPage();
        // navigate('/property')
      },[])
    } else {
      toast.error(response?.error?.messages?.error || 'Login failed. Please try again.')
    }
    setIsLoading(false);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      onSubmit();
    }
  };

  return (
    <Row className='bg-login page' style={{ background: '#1e8a42', minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      {/* Left: Logo Panel */}
      <Col xs={0} sm={0} md={12} lg={12} xl={12}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}
      >
        <Image
          width='auto'
          height='400px'
          src={HeaderLogo}
          alt="Alta Vista Logo"
          preview={false}
        />
      </Col>

      {/* Right: Login Card */}
      <Col xs={24} sm={24} md={12} lg={12} xl={12}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}
      >
        <Space
          direction='vertical'
          align='center'
          style={{
            background: '#e8d8b0',
            borderRadius: '30px',
            width: '100%',
            height: '660px',
            justifyContent: 'center',
          }}
        >
          <Row className='center' style={{ marginBottom: '10px' }}>
            <Col className='login-title' style={{
              fontFamily: "'Cinzel', serif",
              color: '#1e7a3a',
              fontSize: '60px',
              fontWeight: 1000,
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}>
              MEMBERSHIP
            </Col>
          </Row>
          <Row className='center' style={{ marginBottom: '10px' }}>
            <Col className='login-title' style={{
              fontFamily: "'Cinzel', serif",
              color: '#1e7a3a',
              fontSize: '14px',
              fontWeight: 700,
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}>
              LOGIN TO YOUR ACCOUNT
            </Col>
          </Row>

          <Row>
            <Col>
              <Input
                className='login-fields'
                name='email'
                size="large"
                placeholder="Email"
                onChange={(e) => handleChange(e)}
                onKeyDown={handleKeyPress}
                prefix={<UserOutlined style={{ color: '#c8a940' }} />}
                style={{ width: '280px', borderRadius: '6px', border: 'none', background: '#fff' }}
              />
            </Col>
          </Row>

          <Row style={{ marginBottom: '20px' }}>
            <Col>
              <Input.Password
                className='login-fields'
                size='large'
                name='password'
                onChange={(e) => handleChange(e)}
                onKeyDown={handleKeyPress}
                placeholder="Password"
                prefix={<LockOutlined style={{ color: '#c8a940' }} />}
                iconRender={(visible) => (visible ? <EyeTwoTone twoToneColor="#c8a940" /> : <EyeInvisibleOutlined style={{ color: '#c8a940' }} />)}
                style={{ width: '280px', borderRadius: '6px', border: 'none', background: '#fff' }}
              />
            </Col>
          </Row>

          <Row className='center' style={{ marginBottom: '24px' }}>
            <Col>
              {isLoading ? (
                <HashLoader color="#1e7a3a" size={40} />
              ) : (
                <Button
                  type="primary"
                  size='large'
                  onClick={onSubmit}
                  disabled={isLoading}
                  style={{
                    background: '#1e7a3a',
                    border: 'none',
                    borderRadius: '6px',
                    fontFamily: "'Cinzel', serif",
                    fontWeight: 600,
                    letterSpacing: '2px',
                    padding: '0 36px',
                  }}
                >
                  LOGIN
                </Button>
              )}
            </Col>
          </Row>

          <Row className='center'>
            <div style={{ fontSize: '12px', color: '#7a6a45', fontWeight: 600 }}>
              Version 1.0.0
            </div>
          </Row>
        </Space>
      </Col>
    </Row>
  )
}

export default Login
